import { render, staticRenderFns } from "./milestone_module_edit_modal.vue?vue&type=template&id=2f89a2fc&scoped=true"
import script from "./milestone_module_edit_modal.vue?vue&type=script&lang=js"
export * from "./milestone_module_edit_modal.vue?vue&type=script&lang=js"
import style0 from "./milestone_module_edit_modal.vue?vue&type=style&index=0&id=2f89a2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f89a2fc",
  null
  
)

export default component.exports